import React, { Component } from 'react';
import PropTypes from 'prop-types';
import utils from 'utils';
import { analyticsInteraction } from 'utils/analytics';
import { ANALYTICS } from 'constants';
import MessageBanner from 'components/MessageBanner';
import LimitedInventoryModal from 'components/modals/LimitedInventoryModal';
import LimitedAdaptiveEquipment from 'components/modals/LimitedAdaptiveEquipment';
import Extra from 'components/Extra';
import { sanitize } from 'utils/validation';

class IndividualExtras extends Component {
  state = {
    hasWarnedAboutLimitedInventoryItem: false,
    hasWarnedAdaptativeEquipementItem: false,
    isADAopen: false,
  };

  componentDidMount() {
    this.setState({ isADAopen: this.props.hasADAExtra });
  }

  setHasWarnedAboutLimitedInventoryItemToTrue = (hasWarnedAboutLimitedInventoryItemToTrue = true) => {
    this.setState({
      hasWarnedAboutLimitedInventoryItem: hasWarnedAboutLimitedInventoryItemToTrue,
    });
  };

  setHasWarnedAboutAdaptativeEquipementToTrue = (hasWarnedAdaptativeEquipementItemToTrue = true) => {
    this.setState({
      hasWarnedAdaptativeEquipementItem: hasWarnedAdaptativeEquipementItemToTrue,
    });
  };

  toggleADAdevices = () => {
    !this.state.isADAopen && analyticsInteraction(ANALYTICS.DRAWER, ANALYTICS.ADAPTIVE_DRIVING_DEVICES, ANALYTICS.OPEN);
    this.setState((prevState) => ({
      isADAopen: !prevState.isADAopen,
    }));
  };

  render() {
    const { individualExtras, shouldShowTitle, customTitle, scrollRef, isCheckIn, toggleExtrasLoading } = this.props;
    const { hasWarnedAboutLimitedInventoryItem, hasWarnedAdaptativeEquipementItem } = this.state;

    const SubSectionTitleTag = shouldShowTitle ? 'p' : 'h2';
    const { protectionProducts, tripEnhancements, adaEquipment } = individualExtras;

    return (
      <>
        <section ref={scrollRef}>
          {shouldShowTitle && <h2>{customTitle || utils.i18n('extras_add_individual_extras')}</h2>}

          <section className='individual-extras individual-extras--protection-products'>
            <SubSectionTitleTag className='individual-extras-subsection-title'>
              {utils.i18n('extras_protection_products')}
            </SubSectionTitleTag>

            {protectionProducts && !!protectionProducts.length ? (
              protectionProducts.map((extra) => (
                <Extra key={extra.code} toggleExtrasLoading={toggleExtrasLoading} extra={extra} />
              ))
            ) : (
              <MessageBanner
                title={utils.i18n('extras_no_protection_products_available_title')}
                message={utils.i18n('extras_no_protection_products_available_message')}
              />
            )}
          </section>

          <section className='individual-extras individual-extras--trip-enhancements'>
            <SubSectionTitleTag className='individual-extras-subsection-title'>
              {utils.i18n('extras_trip_enhancements')}
            </SubSectionTitleTag>

            {tripEnhancements && !!tripEnhancements.length ? (
              tripEnhancements.map((extra) => (
                <Extra
                  key={extra.code}
                  toggleExtrasLoading={toggleExtrasLoading}
                  hasWarnedAboutLimitedInventoryItem={hasWarnedAboutLimitedInventoryItem}
                  hasWarnedAdaptativeEquipementItem={hasWarnedAdaptativeEquipementItem}
                  setHasWarnedAboutLimitedInventoryItemToTrue={this.setHasWarnedAboutLimitedInventoryItemToTrue}
                  setHasWarnedAboutAdaptativeEquipementToTrue={this.setHasWarnedAboutAdaptativeEquipementToTrue}
                  extra={extra}
                  isCheckIn={isCheckIn}
                  showShortDescription={true}
                />
              ))
            ) : (
              <MessageBanner
                title={utils.i18n('extras_no_trip_enhancements_available_title')}
                message={utils.i18n('extras_no_trip_enhancements_available_message')}
              />
            )}
          </section>

          {!!adaEquipment?.length && (
            <section className='individual-extras individual-extras--ada-equipment'>
              <SubSectionTitleTag className='individual-extras-subsection-title'>
                {utils.i18n('extras_adaptive_driving_devices')}{' '}
                <button
                  onClick={this.toggleADAdevices}
                  className={`individual-extras__accordion-icon ${this.state.isADAopen ? 'expanded' : ''}`}
                ></button>
              </SubSectionTitleTag>

              <p
                className='individual-extras__description'
                dangerouslySetInnerHTML={sanitize(utils.i18n('extras_ada_extra_section_description'))}
              ></p>

              {this.state.isADAopen &&
                adaEquipment.map((extra) => (
                  <Extra
                    key={extra.code}
                    toggleExtrasLoading={toggleExtrasLoading}
                    hasWarnedAboutLimitedInventoryItem={hasWarnedAboutLimitedInventoryItem}
                    hasWarnedAdaptativeEquipementItem={hasWarnedAdaptativeEquipementItem}
                    setHasWarnedAboutLimitedInventoryItemToTrue={this.setHasWarnedAboutLimitedInventoryItemToTrue}
                    setHasWarnedAboutAdaptativeEquipementToTrue={this.setHasWarnedAboutAdaptativeEquipementToTrue}
                    extra={extra}
                    isCheckIn={isCheckIn}
                    showShortDescription={true}
                    isADAEquipment={true}
                  />
                ))}
            </section>
          )}
        </section>
        <LimitedInventoryModal />
        <LimitedAdaptiveEquipment />
      </>
    );
  }
}

IndividualExtras.propTypes = {
  // Container Props
  breakpoint: PropTypes.object,
  individualExtras: PropTypes.object,

  // Parent props
  shouldShowTitle: PropTypes.bool,
  customTitle: PropTypes.string,
  scrollRef: PropTypes.object,
  isCheckIn: PropTypes.bool,
  toggleExtrasLoading: PropTypes.func,
};

export default IndividualExtras;
